import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { REACT_APP_API_URL } from "../../../../../env";

import { setAvailabilityData } from "../../../../../Redux/slice/features/availabilitySlice";
import axios from "axios";
const HotelBlockingForm = () => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState("");
  const [hotels, setHotels] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [selectedRoomType, setSelectedRoomType] = useState("");
  const [checkInDate, setCheckInDate] = useState("");
  const [checkOutDate, setCheckOutDate] = useState("");
  const [numberOfRooms, setNumberOfRooms] = useState("");
  const [newBlockRoom, setNewBlockRoom] = useState("");
  const [Remarks, setRemarks] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [dateError, setDateError] = useState("");
  const [totalRooms, setTotalRooms] = useState(0);
  const [availableRooms, setAvailableRooms] = useState(0);
  const [selectedRoomName, setSelectedRoomName] = useState("");
  const [blockedRoomsInfo, setBlockedRoomsInfo] = useState({
    count: 0,
    fromDate: "",
    toDate: "",
  });

  const dispatch = useDispatch();

  const todayStr = new Date().toISOString().split("T")[0];

  const handleCheckInDateChange = async (e) => {
   
    const value = e.target.value;
    setCheckInDate(value);

    if (value && value < todayStr) {
      setDateError("Check-In date cannot be before today.");
    } else if (checkOutDate && value > checkOutDate) {
      setDateError("Check-In date cannot be after Check-Out date.");
    } else {
      setDateError("");

      if (selectedHotel && checkOutDate && value <= checkOutDate) {
        await fetchRoomConfigs(selectedHotel);

        if (selectedRoomType) {
          try {
            const response = await axios.post(
              `${REACT_APP_API_URL}api/dashboard/admin/total-rooms`,
              {
                P_INTPROPERTYID: selectedHotel,
                P_INTROOMTYPEID: selectedRoomType,
                P_DTFROMDATE: value,
                P_DTTODATE: checkOutDate,
              },
            );
           

            const parsed = parseRoomApiData(response.data.data);
            setTotalRooms(parsed.noOfRooms);
            setAvailableRooms(parsed.availableRooms);
            console.log("Calling RB fetch (check-in change):", {
              hotelId: selectedHotel,
              roomTypeId: selectedRoomType,
              fromDate: value,
              toDate: checkOutDate,
            });
            await fetchRoomBlocking(
              selectedHotel,
              selectedRoomType,
              value,
              checkOutDate,
            );
          } catch (error) {
            console.error("Error updating room availability:", error);
          }
        }
      }
    }
  };

  const handleCheckOutDateChange = async (e) => {
   
    const value = e.target.value;
    setCheckOutDate(value);

    if (checkInDate && value && value < checkInDate) {
      setDateError("Check-Out date cannot be before Check-In date.");
    } else {
      setDateError("");

      if (selectedHotel && checkInDate && value >= checkInDate) {
        await fetchRoomConfigs(selectedHotel);

        if (selectedRoomType) {
          try {
            const response = await axios.post(
              `${REACT_APP_API_URL}api/dashboard/admin/total-rooms`,
              {
                P_INTPROPERTYID: selectedHotel,
                P_INTROOMTYPEID: selectedRoomType,
                P_DTFROMDATE: checkInDate,
                P_DTTODATE: value,
              },
            );
            

            const parsed = parseRoomApiData(response.data.data);
            setTotalRooms(parsed.noOfRooms);
            setAvailableRooms(parsed.availableRooms);
            console.log("Calling RB fetch (check-out change):", {
              hotelId: selectedHotel,
              roomTypeId: selectedRoomType,
              fromDate: checkInDate,
              toDate: value,
            });
            await fetchRoomBlocking(
              selectedHotel,
              selectedRoomType,
              checkInDate,
              value,
            );
          } catch (error) {
            console.error("Error updating room availability:", error);
          }
        }
      }
    }
  };

  const handleCheckAvailability = async (e, hotelId = null) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const targetHotel = hotelId || selectedHotel;

    if (!targetHotel || !checkInDate || !checkOutDate) {
      console.log("Missing required data for availability check");
      return;
    }

    localStorage.setItem("checkInDate", checkInDate);
    localStorage.setItem("checkOutDate", checkOutDate);

    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}api/checkAvailibilty/${targetHotel}`,
        {
          check_in_date: checkInDate,
          check_out_date: checkOutDate,
        },
      );
      console.log("Response from availability check:", response.data);
      if (response.status === 200) {
        console.log("Availability data for tariff:", response.data);
        const availability = response.data.data;
        const roomTariff = response.data.roomConfigs;

        const mergedRooms = availability.map((room) => {
          const matchingTariff = roomTariff.find(
            (tariff) => tariff.RoomTypeId === room.RoomConfigID,
          );
          return {
            ...room,
            ...(matchingTariff || {}),
            HotelRoomConfigID: room.RoomConfigID,
          };
        });

        dispatch(
          setAvailabilityData({
            rooms: mergedRooms,
            check_in_date: checkInDate,
            check_out_date: checkOutDate,
          }),
        );
        setRoomTypes(mergedRooms);
      }
    } catch (error) {
      console.error("Error checking availability:", error);
    }
  };
  const handleNumberOfRoomsChange = (e) => {
    let value = parseInt(e.target.value, 10);
    if (value < 1) {
      value = 1;
    }
    if (totalRooms > 0 && value > totalRooms) {
      value = totalRooms;
    }
    setNumberOfRooms(value);
  };

  const fetchRoomConfigs = async (hotelId) => {
    if (!hotelId) return;

    console.log("Fetching room config for hotelId:", hotelId);
    try {
      const roomConfigResponse = await axios.post(
        `${REACT_APP_API_URL}api/dashboard/admin/get-room-config`,
        {
          P_INTPROPERTYID: hotelId,
          P_CHARACTION: "All",
        },
      );

      const fetchedRoomTypes = roomConfigResponse.data.data || [];
      const activeRoomTypes = fetchedRoomTypes.filter(
        (room) => room.Status === 1,
      );

      console.log("Active room types:", activeRoomTypes);

      const mappedRoomTypes = activeRoomTypes.map((room) => ({
        ...room,
        RoomConfigID: room.RoomConfigID || room.HotelRoomConfigID,
        RoomType: room.RoomType || room.RoomConfigName,
      }));

      setRoomTypes(mappedRoomTypes);

      if (selectedRoomType) {
        const response = await axios.post(
          `${REACT_APP_API_URL}api/dashboard/admin/total-rooms`,
          {
            P_INTPROPERTYID: hotelId,
            P_INTROOMTYPEID: selectedRoomType,
          },
        );

        if (response.data && response.data.data !== undefined) {
          console.log("Total Rooms Response:", response.data);
          const parsed = parseRoomApiData(response.data.data);
          setTotalRooms(parsed.noOfRooms);
          setAvailableRooms(parsed.availableRooms);
        }
      }
    } catch (error) {
      console.error("Error fetching room configurations:", error);
    }
  };

  const fetchRoomBlocking = async (hotelId, roomTypeId, fromDate, toDate) => {
    if (
      hotelId == null ||
      roomTypeId == null ||
      fromDate == null ||
      toDate == null
    )
      return null;

    try {
      const payload = {
        P_INTPROPERTYID: hotelId,
        P_INTROOMTYPEID: roomTypeId,
        P_CHARACTION: "RB",
        P_DTFROMDATE: fromDate,
        P_DTTODATE: toDate,
      };

      const response = await axios.post(
        `${REACT_APP_API_URL}api/dashboard/admin/get-block-room-details`,
        payload,
      );

      console.log("RB response:", response.data);

      const data = response.data && response.data.data;
      if (data !== undefined && data !== null) {
        const source = Array.isArray(data) ? data[0] : data;
        const avail = source?.AvailableRooms || 0;
        setAvailableRooms(avail);

        if (source?.NoOfRooms !== undefined) setTotalRooms(source.NoOfRooms);

        if (source?.BlockRooms !== undefined) {
          setBlockedRoomsInfo({
            count: source.BlockRooms,
            fromDate: fromDate,
            toDate: toDate,
          });
        }
      }

      return response.data;
    } catch (error) {
      console.error("Error fetching room blocking (RB):", error);
      return null;
    }
  };

  const parseRoomApiData = (data) => {
    if (data == null) return { noOfRooms: 0, availableRooms: 0 };

    if (typeof data === "number") {
      return { noOfRooms: data, availableRooms: 0 };
    }

    const src = Array.isArray(data) ? data[0] : data;
    if (typeof src === "number") return { noOfRooms: src, availableRooms: 0 };
    if (typeof src === "object" && src !== null) {
      return {
        noOfRooms: src.NoOfRooms ?? src.NoOfRooms ?? 0,
        availableRooms: src.AvailableRooms ?? 0,
      };
    }
    return { noOfRooms: 0, availableRooms: 0 };
  };

  const fetchRoomDetails = async (
    hotelId,
    roomTypeId,
    fromDate = null,
    toDate = null,
  ) => {
    try {
      const payload = {
        P_INTPROPERTYID: hotelId,
        P_INTROOMTYPEID: roomTypeId,
      };

      if (fromDate && toDate) {
        payload.P_DTFROMDATE = fromDate;
        payload.P_DTTODATE = toDate;
      }

      const response = await axios.post(
        `${REACT_APP_API_URL}api/dashboard/admin/total-rooms`,
        payload,
      );
      console.log("Room Details:", response.data.data);
      const parsed = parseRoomApiData(response.data.data);
      setTotalRooms(parsed.noOfRooms);
      setAvailableRooms(parsed.availableRooms);
    } catch (error) {
      console.error("Error fetching room details:", error);
    }
  };

  const handleHotelChange = async (e) => {
    const hotelId = parseInt(e.target.value);
    setSelectedHotel(hotelId);

    setSelectedRoomType("");
    setTotalRooms(0);
    setAvailableRooms(0);
    setSelectedRoomName("");
    setNumberOfRooms("");

    if (hotelId) {
      console.log("Selected hotelId:", hotelId);

      if (checkInDate && checkOutDate) {
        handleCheckAvailability(null, hotelId);
      }
    } else {
      setRoomTypes([]);
    }
  };

  useEffect(() => {
    if (selectedHotel) {
      fetchRoomConfigs(selectedHotel);
    }
  }, [selectedHotel]);

  const fetchTotalRooms = async (hotelId, roomTypeId) => {
    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}api/dashboard/admin/total-rooms`,
        {
          P_INTPROPERTYID: hotelId,
          P_INTROOMTYPEID: roomTypeId,
        },
      );
      console.log("Total Rooms Available:", response.data.data);
      return response.data.data;
    } catch (error) {
      console.error("Error fetching total rooms:", error);
      return 0;
    }
  };

  const handleRoomTypeChange = async (e) => {
  
    const value = e.target.value;
    if (!value) {
      setSelectedRoomType("");
      setTotalRooms(0);
      setNumberOfRooms("");
      return;
    }

    const roomTypeId = Number(value);
    const selectedRoom = roomTypes.find(
      (room) =>
        room.RoomConfigID === roomTypeId ||
        room.HotelRoomConfigID === roomTypeId,
    );

    if (!selectedRoom) {
      console.error("Selected room not found in roomTypes");
      return;
    }

    console.log("Selected Room:", selectedRoom);
    setSelectedRoomType(roomTypeId);
    setNumberOfRooms("");
    setSelectedRoomName(selectedRoom.RoomType || "");

    try {
      console.log(
        "Fetching total rooms for hotel:",
        selectedHotel,
        "roomType:",
        roomTypeId,
      );
      const response = await axios.post(
        `${REACT_APP_API_URL}api/dashboard/admin/total-rooms`,
        {
          P_INTPROPERTYID: selectedHotel,
          P_INTROOMTYPEID: roomTypeId,
        },
      );

      if (response.data && response.data.data !== undefined) {
        console.log("Total Rooms Response:", response.data);
        setTotalRooms(response.data.data);
        setAvailableRooms(response.data.data.AvailableRooms || 0);
      } else {
        console.error("Invalid response format:", response);
      }

      if (checkInDate && checkOutDate) {
        const availabilityResponse = await axios.post(
          `${REACT_APP_API_URL}api/dashboard/admin/total-rooms`,
          {
            P_INTPROPERTYID: selectedHotel,
            P_INTROOMTYPEID: roomTypeId,
            P_DTFROMDATE: checkInDate,
            P_DTTODATE: checkOutDate,
          },
        );

        if (
          availabilityResponse.data &&
          availabilityResponse.data.data !== undefined
        ) {
          console.log("Date-specific Availability:", availabilityResponse.data);

          const parsed = parseRoomApiData(availabilityResponse.data.data);
          setTotalRooms(parsed.noOfRooms);
          setAvailableRooms(parsed.availableRooms);

          await fetchRoomBlocking(
            selectedHotel,
            roomTypeId,
            checkInDate,
            checkOutDate,
          );
        }
      }
    } catch (error) {
      console.error("Error fetching room details:", error);
    }
  };

  useEffect(() => {
    const fetchHotelData = async () => {
      try {
        const response = await axios.get(
          `${REACT_APP_API_URL}api/room-tariff/get-hotels`,
        );
        console.log("response", response);
        setHotels(response.data.data);
      } catch (error) {
        console.error("Error fetching hotel data:", error);
      }
    };
    fetchHotelData();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!checkInDate || !checkOutDate) {
      setDateError("Both Check-In and Check-Out dates are required.");
      return;
    }
    if (checkInDate < todayStr) {
      setDateError("Check-In date cannot be before today.");
      return;
    }
    if (checkOutDate < checkInDate) {
      setDateError("Check-Out date cannot be before Check-In date.");
      return;
    }
    setDateError("");
    setShowConfirmModal(true);
  };

  const confirmBlocking = async () => {
    setShowConfirmModal(false);

    let hotelId = parseInt(selectedHotel);
    const formData = new FormData();

    formData.append("BlockFrom", checkInDate);
    formData.append("BlockTo", checkOutDate);
    formData.append("BlockRooms", numberOfRooms);
    formData.append("newBlockRoom", newBlockRoom);
    formData.append("RoomConfigID", selectedRoomType);
    formData.append("CreatedBy", 1);
    formData.append("Remarks", Remarks);
    formData.append("customerName", customerName);
    formData.append("TotalRooms", totalRooms);

    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}api/dashboard/admin/hotel-blocking/${hotelId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      // reset form
      setSelectedHotel("");
      setRoomTypes([]);
      setCheckInDate("");
      setCheckOutDate("");
      setNumberOfRooms("");
      setNewBlockRoom("");
      setCustomerName("");

      setRemarks("");

      console.log("Response from blocking:", response.data);
      alert("Room blocked successfully!");
    } catch (error) {
      console.error("Error confirming blocking:", error);
    }
  };
  useEffect(() => {
    if (selectedHotel && selectedRoomType) {
      console.log(
        "Auto fetching room details for:",
        selectedHotel,
        selectedRoomType,
      );
      fetchRoomDetails(selectedHotel, selectedRoomType);
    }
  }, [selectedHotel, selectedRoomType]);

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-header bg-primary text-white">
          <h3 className="mb-0">Hotel Room Blocking Form</h3>
        </div>
        <div className="card-body" style={{ maxWidth: "40%" }}>
          <form onSubmit={handleSubmit} className="d-flex flex-column gap-3">
            <div>
              <label htmlFor="hotelSelect" className="form-label">
                Hotel Name
              </label>
              <select
                className="form-select"
                id="hotelSelect"
                value={selectedHotel}
                onChange={handleHotelChange}
                required
              >
                <option value="">Select Hotel</option>
                {hotels &&
                  hotels.length > 0 &&
                  hotels.map((hotel) => (
                    <option key={hotel.PropertyID} value={hotel.PropertyID}>
                      {hotel.UnitName}
                    </option>
                  ))}
              </select>
            </div>

            <div>
              <label htmlFor="roomSelect" className="form-label">
                Room Type
              </label>
              <select
                className="form-select"
                id="roomSelect"
                value={selectedRoomType || ""}
                onChange={handleRoomTypeChange}
                required
              >
                <option value="">Select Room Type</option>
                {roomTypes &&
                  roomTypes
                    .filter((room) => room.Status === 1)
                    .map((room) => (
                      <option
                        key={room.RoomConfigID || room.HotelRoomConfigID}
                        value={room.RoomConfigID || room.HotelRoomConfigID}
                      >
                        {room.RoomType}
                      </option>
                    ))}
              </select>
            </div>
            <div>
              <label htmlFor="totalRooms" className="form-label">
                Total Rooms
              </label>
              <input
                type="number"
                className="form-control"
                id="totalRooms"
                value={totalRooms}
                min="1"
                required
                readOnly
              />
            </div>

            <div>
              <label htmlFor="fromDate" className="form-label">
                From Date
              </label>
              <input
                type="date"
                className="form-control"
                id="fromDate"
                value={checkInDate}
                onChange={handleCheckInDateChange}
                max={checkOutDate || undefined}
                required
              />
            </div>

            <div>
              <label htmlFor="toDate" className="form-label">
                To Date
              </label>
              <input
                type="date"
                className="form-control"
                id="toDate"
                value={checkOutDate}
                onChange={handleCheckOutDateChange}
                min={checkInDate || todayStr}
                required
              />
            </div>

            <div>
              {/* {blockedRoomsInfo.count > 0 && (
                <div className="alert alert-info mb-2 py-2">
                  <small>
                    <strong>{blockedRoomsInfo.count} rooms</strong> are currently blocked for selected dates{' '}
                  </small>
                </div>
              )} */}
              <label htmlFor="blockRooms" className="form-label">
                Block Rooms
              </label>
              <input
                type="number"
                className="form-control"
                id="blockRooms"
                value={numberOfRooms}
                onChange={handleNumberOfRoomsChange}
                min="1"
                required
              />
            </div>
            <div>
              <label htmlFor="newBlockRoom" className="form-label">
                Newly Blocked Rooms
              </label>
              <input
                type="text"
                className="form-control"
                id="newBlockRoom"
                placeholder="Enter newly blocked rooms"
                value={newBlockRoom}
                onChange={(e) => setNewBlockRoom(e.target.value)}
              />
            </div>

            <div>
              <label htmlFor="customerName" className="form-label">
                Customer Name
              </label>
              <input
                type="text"
                className="form-control"
                id="customerName"
                placeholder="Enter customer name"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
              />
            </div>

            <div>
              <label htmlFor="remarks" className="form-label">
                Remarks
              </label>
              <textarea
                className="form-control"
                id="remarks"
                rows="2"
                placeholder="Enter remarks"
                value={Remarks}
                onChange={(e) => setRemarks(e.target.value)}
              ></textarea>
            </div>

            {dateError && (
              <div className="alert alert-danger py-2">{dateError}</div>
            )}

            <div className="d-grid">
              <button type="submit" className="btn btn-primary">
                Block Room
              </button>
            </div>
          </form>

          <div
            className={`modal fade ${showConfirmModal ? "show" : ""}`}
            style={{ display: showConfirmModal ? "block" : "none" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="confirmModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="confirmModalLabel">
                    Confirm Room Blocking
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowConfirmModal(false)}
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <p>Are you sure you want to block:</p>
                  <ul className="list-unstyled">
                    <li>
                      <strong>Hotel:</strong>{" "}
                      {
                        hotels.find(
                          (h) => h.PropertyID === parseInt(selectedHotel),
                        )?.UnitName
                      }
                    </li>
                    <li>
                      <strong>Customer Name:</strong> {customerName}
                    </li>
                    <li>
                      <strong>Number of Rooms:</strong> {numberOfRooms}
                    </li>
                    <li>
                      <strong>Check-in:</strong> {checkInDate}
                    </li>
                    <li>
                      <strong>Check-out:</strong> {checkOutDate}
                    </li>
                  </ul>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowConfirmModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={confirmBlocking}
                  >
                    Confirm Blocking
                  </button>
                </div>
              </div>
            </div>
          </div>

          {showConfirmModal && <div className="modal-backdrop fade show"></div>}
        </div>
      </div>
    </div>
  );
};

export default HotelBlockingForm;
